import React, { useState } from "react";
import configData from "../../config.json";
import moment from "moment";
import { useMediaQuery } from "react-responsive";
import { downloadFile } from "../../common/utils/fileUtils";
import PrescriptionData from "../../common/Prescriptiondata";

function Rightsidereport({ consultationdata }) {
  const [prescriptiondata, setPrescriptiondata] = useState([]);
  const [showprescriptionmodel, setShowprecriptionmodal] = useState(false);
  const isTabScreen = useMediaQuery({
    query: "(min-width: 768px)" && "(max-width: 1023px)",
  });
  const d = moment().format("DD MMMM YYYY");
  console.log("++", consultationdata);
  const date = {
    fontSize: isTabScreen ? "28px" : "42px",
    color: "#0B57B7",
    fontWeight: "700",
    textAlign: "center",
    lineHeight: "1.1",
    marginTop: "18px",
  };
  const cardWrapper = {
    paddingLeft: "20px",
    paddingRight: "20px",
    display: "flex",
    justifyContent: "center",
  };
  const reportCard = {
    width: "100%",
    maxWidth: "430px",
    background: "linear-gradient(180deg, #EEF8FB 0%, #F8FDFF 100%)",
    border: "1px solid #D7E7EE",
    borderRadius: "18px",
    padding: isTabScreen ? "22px 18px" : "28px 24px",
    boxShadow: "0 10px 30px rgba(16, 89, 152, 0.08)",
  };
  const topMetaRow = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    color: "#0B57B7",
    fontWeight: "700",
    fontSize: isTabScreen ? "16px" : "18px",
  };
  const p = {
    fontSize: isTabScreen ? "15px" : "18px",
    fontWeight: "600",
    color: "#333333",
    textAlign: "center",
    lineHeight: "1.5",
    marginBottom: "12px",
  };
  const p1 = {
    fontSize: isTabScreen ? "14px" : "17px",
    fontWeight: "400",
    color: "#333333",
    textAlign: "center",
    lineHeight: "1.6",
    marginBottom: "24px",
  };
  const pres = {
    fontSize: isTabScreen ? "14px" : "18px",
    fontWeight: "600",
    color: "#0B57B7",
    marginBottom: "10px",
    textAlign: "center",
  };
  const titleStyle = {
    fontSize: isTabScreen ? "24px" : "34px",
    color: "#FF5E8A",
    fontFamily: "Poppins",
    fontWeight: "600",
    textAlign: "center",
    lineHeight: "1.3",
    marginBottom: "8px",
  };
  const actionRow = {
    display: "flex",
    flexDirection: isTabScreen ? "row" : "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "14px",
  };
  const buttonWrap = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minWidth: isTabScreen ? "150px" : "100%",
  };

  const viewreport = () => {
    let fileKey = consultationdata.fileKey;
    if (fileKey) {
      downloadFile(fileKey);
    }
  };
  const viewprescription = () => {
    api
      .getprescriptiondata({
        consultation_id: consultationdata?.id,
      })
      .then((res) => {
        if (res.success) {
          setShowprecriptionmodal(true);
          setPrescriptiondata({
            data: consultationdata,
            medicine: res.Prescrption,
          });
        }
      })
      .catch((rej) => {
        console.log(rej);
      });
  };
  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          paddingTop: "48px",
          fontSize: isTabScreen ? "24px" : "30px",
          fontFamily: "Poppins",
          fontWeight: "500",
          color: "#F0588B",
          textAlign: "center",
        }}
      >
        Prescription & Reports
      </div>
      <hr className="w-100"></hr>
      <div style={cardWrapper}>
        <div style={reportCard}>
          <div style={topMetaRow}>
            <div>{moment(d, "DD MMMM YYYY").format("YYYY")}</div>
            <div>Consultation</div>
          </div>
          <div style={titleStyle}>{consultationdata.title}</div>
          <div style={date}>{moment(d, "DD MMMM YYYY").format("DD MMM")}</div>
          <div style={p}>
            Consulted Dr. {consultationdata?.doctor_firstName}{" "}
            {consultationdata?.doctor_lastName} for gynaec test
          </div>
          <div style={p1}>
            Dr. {consultationdata?.doctor_firstName}{" "}
            {consultationdata?.doctor_lastName} shared 2 records for Mrs.{" "}
            {consultationdata.first_name} {consultationdata?.last_name}
          </div>
          <div style={actionRow}>
            {consultationdata.is_precription && (
              <div style={buttonWrap}>
                <div style={pres}>Prescription</div>
                <button
                  className="btn btn-primary btn-sm"
                  onClick={viewprescription}
                >
                  View Prescription
                </button>
              </div>
            )}
            {consultationdata.fileKey && (
              <div style={buttonWrap}>
                <div style={pres}>Report</div>
                <button className="btn btn-primary btn-sm" onClick={viewreport}>
                  View Report
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      {showprescriptionmodel && (
        <PrescriptionData
          open={showprescriptionmodel}
          data={prescriptiondata}
          onClose={() => {
            setShowprecriptionmodal(false);
            setPrescriptiondata([]);
          }}
        />
      )}
    </div>
  );
}

export default Rightsidereport;
